import { ReportIssueFormValues } from './useReportIssueFormLogic';

type ReportIssueFormErrors = {
  [key in keyof ReportIssueFormValues]?: string;
};
type ValidKeys = keyof ReportIssueFormValues;

export const validateReportIssueFormFields = (
  values: ReportIssueFormValues
): ReportIssueFormErrors | null => {
  const requiredValues: ValidKeys[] = [
    'title',
    'stepsToReproduce',
    'expectedBehavior',
    'severity',
  ];

  const errors = requiredValues.reduce((acc, key) => {
    if (!values[key]) {
      const requiredMessage = `${key} is required`;
      return acc === null
        ? { [key]: requiredMessage }
        : { ...acc, [key]: requiredMessage };
    }
    return acc;
  }, {} as ReportIssueFormErrors);

  return Object.keys(errors).length ? errors : null;
};
